import OadpAttributeDatetime from './oadp-attribute-datetime';
export default OadpAttributeDatetime;
